import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import Navbar from '@/components/Navbar';

export default function HomePage({ user, onLogout }) {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-orange-50 via-white to-blue-50">
      <Navbar user={user} onLogout={onLogout} />

      <div className="max-w-6xl mx-auto px-6 py-12">
        {/* Welcome Section */}
        <div className="text-center mb-16 animate-fade-in">
          <h1 className="text-5xl font-bold text-gray-900 mb-4">
            Welcome, <span className="text-transparent bg-clip-text bg-gradient-to-r from-orange-500 to-blue-600">{user.first_name}!</span>
          </h1>
          <p className="text-xl text-gray-600">Ready to hit the court?</p>
        </div>

        {/* Quick Actions */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6 lg:gap-8 mb-12 sm:mb-16">
          <div
            data-testid="upcoming-games-card"
            onClick={() => navigate('/games')}
            className="bg-white rounded-2xl shadow-lg p-6 sm:p-8 hover-lift cursor-pointer border-2 border-transparent hover:border-orange-500"
          >
            <div className="text-4xl sm:text-5xl mb-3 sm:mb-4">🏐</div>
            <h3 className="text-xl sm:text-2xl font-bold mb-2 text-gray-900">Upcoming Games</h3>
            <p className="text-sm sm:text-base text-gray-600">View and register for upcoming volleyball games</p>
          </div>

          <div
            data-testid="about-club-card"
            onClick={() => navigate('/about')}
            className="bg-white rounded-2xl shadow-lg p-6 sm:p-8 hover-lift cursor-pointer border-2 border-transparent hover:border-blue-500"
          >
            <div className="text-4xl sm:text-5xl mb-3 sm:mb-4">ℹ️</div>
            <h3 className="text-xl sm:text-2xl font-bold mb-2 text-gray-900">About the Club</h3>
            <p className="text-sm sm:text-base text-gray-600">Learn more about NL Volleyball</p>
          </div>

          <div
            data-testid="my-profile-card"
            onClick={() => navigate('/profile')}
            className="bg-white rounded-2xl shadow-lg p-6 sm:p-8 hover-lift cursor-pointer border-2 border-transparent hover:border-purple-500"
          >
            <div className="text-4xl sm:text-5xl mb-3 sm:mb-4">👤</div>
            <h3 className="text-xl sm:text-2xl font-bold mb-2 text-gray-900">My Profile</h3>
            <p className="text-sm sm:text-base text-gray-600">View and edit your profile information</p>
          </div>

          <div
            data-testid="my-stats-card"
            onClick={() => navigate('/my-stats')}
            className="bg-white rounded-2xl shadow-lg p-6 sm:p-8 hover-lift cursor-pointer border-2 border-transparent hover:border-green-500"
          >
            <div className="text-4xl sm:text-5xl mb-3 sm:mb-4">📊</div>
            <h3 className="text-xl sm:text-2xl font-bold mb-2 text-gray-900">My Stats</h3>
            <p className="text-sm sm:text-base text-gray-600">View your performance and ratings</p>
          </div>

          <div
            data-testid="leaderboards-card"
            onClick={() => navigate('/leaderboards')}
            className="bg-white rounded-2xl shadow-lg p-6 sm:p-8 hover-lift cursor-pointer border-2 border-transparent hover:border-yellow-500"
          >
            <div className="text-4xl sm:text-5xl mb-3 sm:mb-4">🏆</div>
            <h3 className="text-xl sm:text-2xl font-bold mb-2 text-gray-900">Leaderboards</h3>
            <p className="text-sm sm:text-base text-gray-600">Compete with the best players</p>
          </div>

          <div
            data-testid="archived-games-card"
            onClick={() => navigate('/games#archived')}
            className="bg-white rounded-2xl shadow-lg p-6 sm:p-8 hover-lift cursor-pointer border-2 border-transparent hover:border-gray-500"
          >
            <div className="text-4xl sm:text-5xl mb-3 sm:mb-4">📦</div>
            <h3 className="text-xl sm:text-2xl font-bold mb-2 text-gray-900">Archived Games</h3>
            <p className="text-sm sm:text-base text-gray-600">View past completed games</p>
          </div>

          {user.is_admin && (
            <div
              data-testid="admin-dashboard-card"
              onClick={() => navigate('/admin')}
              className="bg-gradient-to-br from-orange-500 to-orange-600 rounded-2xl shadow-lg p-6 sm:p-8 hover-lift cursor-pointer text-white"
            >
              <div className="text-4xl sm:text-5xl mb-3 sm:mb-4">⚙️</div>
              <h3 className="text-xl sm:text-2xl font-bold mb-2">Admin Dashboard</h3>
              <p className="text-sm sm:text-base text-orange-100">Manage games and users</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
